import React from 'react';

import { Form, Button, Select, Modal, InputNumber } from 'antd';
import Spacer from 'components/ui/Spacer';

import { YuhuModules, ValidTriggers, Actions, CalculationTypes, PercentCalc } from './constants';

const yuhuModuleOptions = Object.keys(YuhuModules).map((m) => ({
  value: m,
  label: YuhuModules[m],
}));

const actionOptions = Object.keys(Actions).map((a) => ({ value: a, label: Actions[a] }));

const calcTypeOptions = Object.keys(CalculationTypes).map((t) => ({
  value: t,
  label: CalculationTypes[t],
}));

const FEE_EVENT_FORM = 'fee_event_form';

const requiredField = {
  required: true,
  message: 'Required field',
};

const FeeEventEditModal = ({ visible, handleClose, feeEventData }) => {
  const [form] = Form.useForm();
  const selectedYuhuModule = Form.useWatch('yuhu_module', form);

  const handleSubmit = (values) => {
    feeEventData.onUpdate(values);
    handleClose();
  };

  const handleClickCancel = () => {
    form.resetFields();
    handleClose();
  };

  return (
    <Modal
      visible={visible}
      title="Add event"
      onCancel={handleClickCancel}
      footer={[
        <Button key="back" onClick={handleClickCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Save changes
        </Button>,
      ]}
    >
      <Form
        layout="vertical"
        name={FEE_EVENT_FORM}
        form={form}
        initialValues={feeEventData}
        onFinish={handleSubmit}
      >
        <Form.Item name="id" hidden />

        <Spacer mb={1}>
          <Form.Item name="yuhu_module" label="Associated module" rules={[requiredField]}>
            <Select
              onChange={() => form.setFieldsValue({ trigger: null })}
              options={yuhuModuleOptions}
            />
          </Form.Item>
        </Spacer>

        <Spacer mb={1}>
          <Form.Item name="trigger" label="Trigger" rules={[requiredField]}>
            <Select
              disabled={!selectedYuhuModule}
              options={selectedYuhuModule ? ValidTriggers[selectedYuhuModule] : []}
            />
          </Form.Item>
        </Spacer>

        <Spacer mb={1}>
          <Form.Item name={'action'} label="Action" rules={[requiredField]}>
            <Select options={actionOptions} />
          </Form.Item>
        </Spacer>

        <Spacer mb={1}>
          <Form.Item name="calculation_type" label="Calculation type" rules={[requiredField]}>
            <Select options={calcTypeOptions} />
          </Form.Item>
        </Spacer>

        <Spacer mb={1}>
          <Form.Item
            shouldUpdate={(prevValues, curValues) =>
              prevValues.calculation_type !== curValues.calculation_type
            }
          >
            {({ getFieldValue }) => {
              const calculation_type = getFieldValue('calculation_type') || PercentCalc;
              return calculation_type === PercentCalc ? (
                // [Ant Design]: Input number formatter documentation
                // https://ant.design/components/input-number/#components-input-number-demo-formatter
                <Form.Item name={'percent_value'} label="Amount" rules={[requiredField]}>
                  <InputNumber min={0} max={100} addonAfter="%" />
                </Form.Item>
              ) : (
                <Form.Item name={'amount_value'} label="Amount" rules={[requiredField]}>
                  <InputNumber
                    min={0}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    addonAfter="$"
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Spacer>
      </Form>
    </Modal>
  );
};

export default FeeEventEditModal;
